import { GamePhase, GameState } from '../types';
import { DiceType } from '../models/DiceModel';
import { GroschenService } from '../services/GroschenService';

interface UseBettingParams {
  setGameState: React.Dispatch<React.SetStateAction<GameState>>;
  setShowGameScreen: (show: boolean) => void;
  initializeDiceWithConfig: () => any[];
  initialState: GameState;
}

export const useBetting = ({
  setGameState,
  setShowGameScreen,
  initializeDiceWithConfig,
  initialState,
}: UseBettingParams) => {
  const handlePlaceBet = (amount: number) => {
    setGameState(prevState => {
      const updatedPlayer = GroschenService.reduceGroschen(
        prevState.players[0],
        prevState.diceConfigs,
        amount,
        'place_bet',
        prevState.settings
      );

      const newPlayers = [...prevState.players];
      newPlayers[0] = updatedPlayer;

      return {
        ...prevState,
        bet: amount,
        players: newPlayers,
      };
    });

    setShowGameScreen(true);
    setGameState(prevState => {
      const newState = {
        ...initialState,
        phase: GamePhase.ROLL as GamePhase,
        settings: prevState.settings,
        diceConfigs: prevState.diceConfigs,
        dice: initializeDiceWithConfig(),
        bet: amount,
        players: [
          {
            name: 'player_0',
            score: 0,
            turnScore: 0,
            isComputer: false,
            groschen: prevState.players[0].groschen,
            ownedDice: prevState.players[0].ownedDice,
          },
          {
            name: 'computer_1',
            score: 0,
            turnScore: 0,
            isComputer: true,
            groschen: 0,
            ownedDice: [DiceType.NORMAL],
          },
        ],
      };

      GroschenService.setGroschen(
        newState.players[0],
        newState.diceConfigs,
        newState.players[0].groschen,
        'start_new_game',
        newState.settings
      );

      return newState;
    });
  };

  return { handlePlaceBet };
};
